import { HistoryOutline18Icon } from "@vygruppen/spor-icon-react";
import {
  COMPANYCODE,
  FilterType,
  ROLE,
  initStates,
} from "features/CenterContent/RoleContent/Personellstyrer/DayPlanTrackings/TableFilter/constants";
import { MiniDatePicker } from "features/CenterContent/RoleContent/Personellstyrer/DayPlanTrackings/TableFilter/MiniDatePicker";
import { FilterCardSelect } from "features/History/Filter/FilterCardSelect";
import { filterRoteToNorwegian } from "features/History/Filter/FilterData";
import { useTranslation } from "react-i18next";
import { CheckmarkDropsButton } from "shared/components/CheckmarkDropsButton";
import { Checkbox, DropsButton, Field, HStack } from "shared/components/Spor";
import styled from "styled-components";

interface TableFilterProps {
  setFilterParams: (update: (prev: FilterType) => FilterType) => void;
  filterParams: FilterType;
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const TableFilter = ({ setFilterParams, filterParams }: TableFilterProps) => {
  const { t } = useTranslation();
  const isDefault =
    filterParams.showClosed === initStates.showClosed &&
    filterParams.showFuture === initStates.showFuture &&
    filterParams.showDeleted === initStates.showDeleted &&
    filterParams.role === initStates.role &&
    filterParams.companyCode === initStates.companyCode &&
    filterParams.chosenDate.year === initStates.chosenDate.year &&
    filterParams.chosenDate.month === initStates.chosenDate.month &&
    filterParams.chosenDate.day === initStates.chosenDate.day;

  function translateCompanyCodeToNO(companyCode: COMPANYCODE) {
    switch (companyCode) {
      case COMPANYCODE.VY:
        return "VY";
      case COMPANYCODE.VYT:
        return "VYT";
      case COMPANYCODE.ALL:
        return "Alle";
    }
  }

  return (
    <Container>
      <FilterCardSelect
        label={`Rolle: ${t(filterRoteToNorwegian(filterParams.role))}`}
      >
        {Object.values(ROLE).map((role) => (
          <CheckmarkDropsButton
            key={role}
            checked={filterParams.role === role}
            onClick={() => setFilterParams((prev) => ({ ...prev, role }))}
          >
            {t(filterRoteToNorwegian(role))}
          </CheckmarkDropsButton>
        ))}
      </FilterCardSelect>
      <FilterCardSelect
        label={`Selskap: ${t(translateCompanyCodeToNO(filterParams.companyCode))}`}
      >
        {Object.values(COMPANYCODE).map((code) => (
          <CheckmarkDropsButton
            key={code}
            checked={filterParams.companyCode === code}
            onClick={() =>
              setFilterParams((prev) => ({
                ...prev,
                companyCode: code,
              }))
            }
          >
            {t(translateCompanyCodeToNO(code))}
          </CheckmarkDropsButton>
        ))}
      </FilterCardSelect>

      <HStack gap="12px">
        {[
          { key: "showClosed", label: "Vis lukkede" },
          { key: "showFuture", label: "Vis frem i tid" },
          { key: "showDeleted", label: "Vis slettede" },
        ].map(({ key, label }) => (
          <Checkbox
            key={key}
            checked={filterParams[key as keyof typeof filterParams] as boolean}
            onCheckedChange={(event) => {
              setFilterParams((prev) => ({
                ...prev,
                [key]: !!event.checked,
              }));
            }}
          >
            {label}
          </Checkbox>
        ))}
      </HStack>

      <Field maxWidth="max-content" pl="6px">
        <MiniDatePicker
          value={filterParams.chosenDate}
          onChange={(date) => {
            if (date !== null)
              setFilterParams((prev) => ({ ...prev, chosenDate: date }));
          }}
        />
      </Field>
      {!isDefault && (
        <DropsButton
          variant="ghost"
          size="xs"
          onClick={() => {
            setFilterParams(() => ({ ...initStates }));
          }}
          leftIcon={<HistoryOutline18Icon />}
        >
          {t("Tilbakestill filter")}
        </DropsButton>
      )}
    </Container>
  );
};

export { TableFilter };
